<template>
  <svg
    class="whatsapp-icon"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
  >
    <path
      fill="currentColor"
      d="M12.04 2C6.53 2 2.05 6.45 2.05 11.93c0 1.75.46 3.45 1.33 4.95L2 22l5.25-1.37a10.02 10.02 0 0 0 4.78 1.21h.01c5.5 0 9.98-4.45 9.98-9.93C22.02 6.45 17.54 2 12.04 2Zm0 18.16h-.01a8.3 8.3 0 0 1-4.23-1.15l-.3-.18-3.11.81.83-3.02-.2-.31a8.16 8.16 0 0 1-1.28-4.38c0-4.55 3.72-8.25 8.3-8.25 4.57 0 8.29 3.7 8.29 8.25 0 4.54-3.72 8.23-8.29 8.23Zm4.55-6.17c-.25-.12-1.48-.73-1.71-.81-.23-.08-.39-.12-.56.12-.16.25-.64.81-.79.98-.14.16-.29.18-.54.06-.25-.12-1.05-.39-2-1.23-.74-.65-1.24-1.46-1.38-1.71-.15-.25-.02-.38.11-.5.11-.11.25-.29.37-.43.13-.14.17-.25.25-.41.08-.17.04-.31-.02-.43-.06-.13-.56-1.34-.76-1.83-.2-.48-.41-.42-.56-.43h-.48c-.17 0-.44.06-.67.31-.23.25-.87.85-.87 2.07 0 1.22.89 2.4 1.01 2.56.13.17 1.75 2.66 4.24 3.73.59.25 1.05.41 1.41.52.59.19 1.13.16 1.56.1.48-.07 1.48-.61 1.69-1.19.21-.59.21-1.09.15-1.19-.06-.11-.23-.17-.48-.29Z"
    />
  </svg>
</template>

<style scoped>
.whatsapp-icon {
  width: 1em;
  height: 1em;
  display: inline-block;
  flex: 0 0 auto;
}
</style>
